import { Button } from '@/components/ui/button';
import { ArrowRight, Calendar, CheckCircle } from 'lucide-react';
import ctaBackground from '@/assets/shooting-wedding-event.jpg';

const CTA = () => {
  const benefits = [
    'Free 30-minute consultation',
    'Custom strategy proposal',
    'No obligation to commit',
  ];

  return (
    <section className="py-16 sm:py-24 bg-foreground relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: `url(${ctaBackground})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground via-foreground/95 to-foreground/80" />
      
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-primary/10 to-transparent" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary/20 rounded-full blur-3xl -translate-x-1/2 translate-y-1/2 hidden sm:block" />
      
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-background/10 backdrop-blur-sm border border-background/20 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-6 sm:mb-8">
            <Calendar className="w-4 h-4 text-primary" />
            <span className="text-background/90 text-xs sm:text-sm font-medium">
              Limited spots available this month
            </span>
          </div>

          {/* Headline */}
          <h2 className="font-display font-bold text-2xl sm:text-4xl lg:text-5xl text-background mb-4 sm:mb-6">
            Ready to Elevate Your
            <span className="block mt-1 sm:mt-2 text-primary">Brand's Presence?</span>
          </h2>

          <p className="text-base sm:text-xl text-background/80 max-w-2xl mx-auto mb-6 sm:mb-8">
            Book a free discovery call and let's discuss how we can help you attract more clients and grow your business through strategic media.
          </p>

          {/* Benefits */}
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-6 mb-8 sm:mb-10">
            {benefits.map((benefit) => (
              <div key={benefit} className="flex items-center gap-2 justify-center">
                <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-primary flex-shrink-0" />
                <span className="text-sm sm:text-base text-background/90">{benefit}</span>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <Button variant="hero" size="xl" className="group text-base sm:text-lg w-full sm:w-auto" asChild>
            <a href="/booking">
              Book Your Discovery Call
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </Button>

          <p className="mt-4 sm:mt-6 text-background/60 text-xs sm:text-sm">
            Trusted by 50+ businesses across Ohio
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;
